import React from 'react';
import { withRouter } from 'inferno-router';
import { StyleSheet, View, Text } from './base_components';
import Link from './link';
import Select from './select';
import ImageButton from './buttons/image_button';

import UserStore from '../stores/user_store';

const styles = StyleSheet.create({
  header: {
    alignSelf: 'stretch',
    flexDirection: 'column',
  },
  top: {
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  spacer: {
    flex: 1,
  },
  logo: {
    width: '5em',
    height: '5em',
    marginRight: '1em',
  },
  headerText: {
    fontSize: '1.4em',
    fontWeight: 'bold',
  },
  orgText: {
    marginLeft: '3em',
    marginRight: '0.5em',
    fontSize: '1em',
    fontWeight: 'bold',
  },
  orgSelect: {
    paddingLeft: '1em',
    paddingRight: '1em',
    height: '2em',
    color: 'black',
    fontSize: '1em',
    fontWeight: 'bold',
    backgroundColor: '#ccc',
    borderRadius: '0.3em',
  },
  line: {
    alignSelf: 'stretch',
    height: '1px',
    backgroundColor: 'black',
  },
  userText: {
    marginRight: '1em',
  },
});

const LOGO_IMG = require('../assets/img/logo.png');

type Props = {
  style?: any;
  hideOrg?: boolean;
};
type State = {
  user: any;
  org_list: [any] | null;
  current_org_id: string;
};

class Header extends React.PureComponent<Props, State> {
  constructor(props, context) {
    super(props, context);
    const user = UserStore.getUser();
    let org_list = null;
    if (user && user.org_list) {
      org_list = user.org_list.sort(_sortOrg);
    }
    this.state = {
      user,
      org_list,
      current_org_id: '',
    };
  }
  componentDidMount() {
    UserStore.addChangeListener(this._onUserUpdate);
    this._onUserUpdate();
  }
  componentWillUnmount() {
    UserStore.removeChangeListener(this._onUserUpdate);
  }
  _onUserUpdate = () => {
    const current_org_id = UserStore.getCurrentOrgId();
    this.setState({ current_org_id: String(current_org_id) });
  };
  _onOrgChange = (current_org_id: string) => {
    UserStore.setCurrentOrgId(current_org_id);
    this.setState({ current_org_id });
  };
  _onMonpPress = () => {
    this.props.history.push('/');
  };

  render() {
    const { style, hideOrg } = this.props;
    const { user, org_list, current_org_id } = this.state;

    let org_drop = null;
    if (org_list && org_list.length > 1 && !hideOrg) {
      const options = [
        ...org_list.map((o) => ({
          value: o.org_id,
          text: o.org_name,
        })),
      ];

      org_drop = (
        <>
          <Text style={styles.orgText}>Org:</Text>
          <Select
            style={styles.orgSelect}
            options={options}
            value={current_org_id}
            onChange={this._onOrgChange}
          />
        </>
      );
    } else if (org_list && org_list.length === 1 && !hideOrg) {
      const { org_name } = org_list[0];
      org_drop = <Text style={styles.orgText}>Org: {org_name}</Text>;
    }

    return (
      <View style={[styles.header, style]}>
        <View style={styles.top}>
          <ImageButton
            style={styles.logo}
            source={LOGO_IMG}
            resizeMode='contain'
            onPress={this._onMonpPress}
          />
          <Text style={styles.headerText}>MONP ABT</Text>
          {org_drop}
          <View style={styles.spacer} />
          <Text style={styles.userText}>{user.user_name}</Text>
          <Link href='/logout' text='Logout' />
        </View>
        <View style={styles.line} />
      </View>
    );
  }
}
export default withRouter(Header);

function _sortOrg(a, b) {
  return a.org_id - b.org_id;
}
